import type { IUserChipData } from '../_header'
import { _chips } from '../config'

export const userChips = (_userChips: IUserChipData[]) =>
  Object.entries(_chips).map(([_id, item]) => ({
    ...item,
    collected: _userChips.some((collectedItem) => collectedItem._id === _id),
  }))
